var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8131 5.85887C24.5288 4.78908 23.6937 3.9495 22.6329 3.66512C20.71 3.14603 13.0003 3.14603 13.0003 3.14603C13.0003 3.14603 5.29056 3.14603 3.36764 3.66512C2.30688 3.9495 1.47181 4.78908 1.18743 5.85887C0.672852 7.79533 0.672852 11.8307 0.672852 11.8307C0.672852 11.8307 0.672852 15.8662 1.18743 17.8026C1.47181 18.8724 2.30688 19.6759 3.36764 19.9603C5.29056 20.4794 13.0003 20.4794 13.0003 20.4794C13.0003 20.4794 20.71 20.4794 22.6329 19.9603C23.6937 19.6759 24.5288 18.8679 24.8131 17.8026C25.3277 15.8662 25.3277 11.8307 25.3277 11.8307C25.3277 11.8307 25.3277 7.79533 24.8131 5.85887ZM10.4815 15.496V8.16547L16.9229 11.8307L10.4815 15.496Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/1 (3).ba5e1143241357dcb9a689b97b4b5410.svg";
export { ForwardRef as ReactComponent };